/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 27/03/19.
 *
 * Version : Generator 2.0.9
 */

export class UtilMpaFunction {
    /**
     * Last Timestamp Egylis
     */
    private static LAST_TIMESTAMP_EGYLIS: number = -1;
    private static LAST_TIMESTAMP_MS: number = -1;

    /**
     * Get Timestamp Egylis
     */
    public static getTimeStampMadeInEgylis(): number {
        const currentMS = Date.now();
        if (currentMS === this.LAST_TIMESTAMP_MS) {
            this.LAST_TIMESTAMP_EGYLIS = this.LAST_TIMESTAMP_EGYLIS + 1;
        } else {
            this.LAST_TIMESTAMP_MS = currentMS;
            this.LAST_TIMESTAMP_EGYLIS = this.LAST_TIMESTAMP_MS *
                Math.round(Math.pow(10, (15 - Math.round(Math.floor(Math.log10(this.LAST_TIMESTAMP_MS))))));
        }
        return this.LAST_TIMESTAMP_EGYLIS;
    }

    /**
     * Erzeugt eine UUID nach RFC 4122
     */
    public static uuid(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
            // tslint:disable-next-line:no-bitwise
            const random = Math.random() * 16 | 0; // Nachkommastellen abschneiden
            const value = char === 'x' ? random : (random % 4 + 8);
            // Bei x Random 0-15 (0-F), bei y Random 0-3 + 8 = 8-11 (8-b) gemäss RFC 4122
            return value.toString(16); // Hexadezimales Zeichen zurückgeben
        });
    }
}
